import axios from 'axios'

// 카카오 토큰 발급
export const getKakaoToken = async () => {
  const token = new URL(window.location.href).searchParams.get('code')
  const res = axios.post(
    'https://kauth.kakao.com/oauth/token',
    {
      grant_type: 'authorization_code',
      client_id: process.env.REACT_APP_KAKAO_CLIENT_ID,
      redirect_uri: `${process.env.REACT_APP_SHOP_URL}/myshopping/oauth`,
      code: token,
    },
    {
      headers: {
        'Content-type': 'application/x-www-form-urlencoded;charset=utf-8',
      },
    }
  )
  return res
}

// 카카오 유저 데이터 가져오기
export async function getUserData(token: string) {
  return await axios.get(`https://kapi.kakao.com/v2/user/me`, {
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-type': 'application/x-www-form-urlencoded;charset=utf-8',
    },
  })
}
